import * as cache from './cache.js';
import { APIBASE } from './config.js';
import { notAuthenticatedError } from './errors.js';
import { authToken, selectedOwnerIds } from './internal.js';
import { retrying } from '@debbie/common/dist/util/retry.js';
import { UnauthorizedError } from '@debbie/common/dist/util/errors.js';
// TODO: Make work in IE if neccesary
const queryParamAdder = (url, params) => {
    const u = new URL(url);
    Object.keys(params).map((key) => {
        u.searchParams.set(key, params[key]);
    });
    return u.href;
};
export const buildServiceAPI = (service) => (base) => buildAPI(`${service}${base}`);
export const buildAPI = (base) => (method, path, options = {}) => {
    const selectedOwnerIdsAsQueryParameter = (method === 'GET' ||
        method === 'DELETE' ||
        (options.body && Array.isArray(options.body))) &&
        selectedOwnerIds.length !== 0;
    return genericRequest(queryParamAdder(APIBASE + base + (path || ''), selectedOwnerIdsAsQueryParameter
        ? {
            selectedOwnerIds: JSON.stringify(selectedOwnerIds),
        }
        : {}), {
        method,
        body: JSON.stringify(!selectedOwnerIdsAsQueryParameter && selectedOwnerIds.length !== 0
            ? { selectedOwnerIds, ...options.body }
            : options.body),
    }, options);
};
const retryingStatusCodes = [408, 429, 500, 502, 503, 504, 507, 509];
const retryingFetch = retrying((...args) => fetch(...args).then((r) => {
    if (retryingStatusCodes.includes(r.status)) {
        throw new Error('Should retry');
    }
    return r;
}), {
    maxAttempts: 4,
    lastAttemptFn: fetch,
});
const genericRequest = (path, requestOptions = {}, options = {}) => {
    return (requestOptions.method !== 'GET' && options.cache == null) ||
        (options.force != null && options.force) ||
        true
        ? (requestOptions.method === 'GET' ? retryingFetch : fetch)(`${path}`, {
            headers: authToken != ''
                ? {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                    'X-Debbie-Auth-Token': authToken,
                }
                : {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
            ...requestOptions,
        })
            .then((res) => res.json())
            .then((res) => {
            if (res.statusCode === 401) {
                // Unauthorized
                throw new UnauthorizedError(res.message);
            }
            if (res.status >= 400 || res.statusCode >= 400) {
                if (typeof res.message !== 'undefined') {
                    throw new Error(typeof res.message === 'object'
                        ? JSON.stringify(res.message)
                        : res.message);
                }
                if (res.error) {
                    throw res.error;
                }
                else {
                    throw new Error('Something went wrong');
                }
            }
            return res;
        })
            .then((res) => {
            if (res.status == 'Not authenticated.') {
                throw notAuthenticatedError;
            }
            return res;
        })
            .then(async (res) => {
            if (options.cache != null) {
                await cache.set(options.cache.name, res, {
                    duration: options.cache.duration,
                });
            }
            else if (requestOptions.method === 'GET') {
                await cache.set(path, res);
            }
            return res;
        })
        : (options.cache != null
            ? cache.get(options.cache.name)
            : cache.get(path)).then((res) => {
            if (res == null) {
                return genericRequest(path, requestOptions, {
                    ...options,
                    force: true,
                });
            }
            return res;
        });
};
// Skeleton
export const createAPI = (apiBase) => (resourcePath, scoped = true) => (method, path, options = {}, requestOptions = {}) => genericRequest(`${APIBASE}${apiBase}${scoped ? `/${selectedOwnerIds[0]}` : ''}${resourcePath}${path}`, {
    ...requestOptions,
    method: method,
    body: options.body ? JSON.stringify(options.body) : undefined,
}, options);
//# sourceMappingURL=requests.js.map